import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FAQ } from '@/lib/content';

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#f2e8ce] py-24 md:py-32"
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-8">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs uppercase tracking-[0.3em] text-[#a1802f] mb-6"
        >
          Questions fréquentes
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-serif font-light text-[#1c1811] text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight mb-14"
        >
          Vos questions,
          <br />
          <span className="italic text-[#a1802f]">mes réponses</span>.
        </motion.h2>

        <Accordion type="single" collapsible className="w-full">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#1c1811]/25"
            >
              <AccordionTrigger className="font-serif text-xl md:text-2xl text-[#1c1811] hover:no-underline py-6 [&>svg]:text-[#a1802f] [&>svg]:h-5 [&>svg]:w-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#1c1811]/70 text-base md:text-lg leading-relaxed pb-6 pr-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
